import React, { useState } from 'react';
import { Button, Input } from 'Components';
import { useJourneyContext } from 'Contexts';
import { useEffectOnce } from 'Hooks';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Password: React.FC<Props> = ({ placeholder, onChange, ...rest }) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { readOnly, setReadOnly } = useJourneyContext();

  useEffectOnce(() => {
    setReadOnly(false);
  });

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => onChange && onChange(event);

  return (
    <span className="flex relative items-center">
      <Input
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        name="password"
        readOnly={readOnly}
        onChange={handleChange}
        className="shrink-0 pr-28 focus:outline-2 focus:outline outline-blue hide-password-reveal"
        {...rest}
      />
      <span className="absolute left-auto right-2">
        <Button onClick={togglePassword} type="button" variant="tertiary">
          {showPassword ? 'Masquer' : 'Afficher'}
        </Button>
      </span>
    </span>
  );
};
